import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { PersonInMarinaDTO, PersonInMarinaFilter } from 'src/app/models/dtos/access-controller/person-in-marina.dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PersonInMarinaService {
  private readonly baseUrl = environment.apiHost + '/api-core/secure/person-in-marina';

  constructor(private http: HttpClient) {}

  listCurrentlyInMarina(filter?: PersonInMarinaFilter): Observable<PersonInMarinaDTO[]> {
    let params = new HttpParams();
    if (filter?.type) {
      params = params.set('type', filter.type);
    }
    if (filter?.isResponsiblePresent !== undefined && filter?.isResponsiblePresent !== null) {
      params = params.set('isResponsiblePresent', String(filter.isResponsiblePresent));
    }

    return this.http
      .get<PersonInMarinaDTO[]>(this.baseUrl + '/list', { params })
      .pipe(map((response: any) => (Array.isArray(response) ? response : response?.data ?? [])));
  }
}
